// extracted by mini-css-extract-plugin
export default {"picture":"Picture_picture__0Z+Vf","add-wrapper":"Picture_add-wrapper__69LlP","wrapper":"Picture_wrapper__zJktp","file-input":"Picture_file-input__F45-K"};